/* global Vimeo */
/* global IntersectionObserver */

import { h } from 'preact'; /** @jsx h */
import { useEffect } from 'preact/hooks';

import './Video.scss';

const Video = ({ src, padding, caption = false }) => {
    // useEffect for Vimeo videos and IntersectionObserver for autoplay/pause
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        document.body.appendChild(script);

        script.onload = () => {
            const videos = document.querySelectorAll('.vimeo-wrapper iframe');

            videos.forEach(video => {
                const player = new Vimeo.Player(video);

                const observer = new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                player.play();
                            } else {
                                player.pause();
                            }
                        });
                    },
                    {
                        threshold: 0.5
                    }
                );

                observer.observe(video);
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="video-container video">
            <div className="vimeo-wrapper" style={`padding: ${padding} 0 0 0;`}>
                <iframe
                    src={src}
                    style="position:absolute;top:0;left:0;width:100%;height:100%;"
                    frameBorder="0"
                    allow="autoplay"
                    allowFullScreen
                ></iframe>
            </div>
            {caption && <figcaption>{caption}</figcaption>}
        </div>
    );
};

export default Video;
